export const SELECT_SKUS_TABLE_ID = 38;
export const SELECT_STORES_TABLE_ID = 37;
